var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3276",
    "data-name": "Rectangle 3276",
    width: 24,
    height: 24,
    transform: "translate(1149 316)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_112",
    "data-name": "Mask Group 112",
    transform: "translate(-1149 -316)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6848",
    "data-name": "Group 6848",
    transform: "translate(1152.77 317.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6847",
    "data-name": "Group 6847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6845",
    "data-name": "Group 6845",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7432",
    "data-name": "Path 7432",
    d: "M10.466,1H2.446A1.446,1.446,0,0,0,1,2.446V19.289a1.446,1.446,0,0,0,1.446,1.446H15.308a1.445,1.445,0,0,0,1.446-1.446V7.6Z",
    transform: "translate(-0.512 -0.512)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7433",
    "data-name": "Path 7433",
    d: "M26.678,7.6h-4.6a1.687,1.687,0,0,1-1.687-1.688V1",
    transform: "translate(-10.436 -0.512)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6846",
    "data-name": "Group 6846",
    transform: "translate(4.625 10.356)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_591",
    "data-name": "Line 591",
    y2: 3.74,
    transform: "translate(3.74 3.74)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_592",
    "data-name": "Line 592",
    y2: 2.137,
    transform: "translate(3.74)",
    fill: "none",
    stroke: "#0a64f9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_593",
    "data-name": "Line 593",
    y2: 7.48,
    transform: "translate(7.48 3.74) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e178e1376cde8be56774ed9fddc2fdb5.svg";
export { ForwardRef as ReactComponent };